import React, { useEffect, useState } from 'react';
import {  Link, useNavigate } from 'react-router-dom';
import { Country } from "country-state-city";
import { toast } from "react-toastify";
import logo from "../../assets/onnize.png";
import { api } from "../../app/Api/ApiSlice";

const Signup = () => {
    const [firstname, setFirstname] = useState("");
    const [username, setusername] = useState(""); //this is a honeypot
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false); 
    const [phone, setPhone] = useState("");
    const [country, setCountry] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [allCountries, setAllCountries] = useState([]);

    const navigate = useNavigate()


    /**
     * UPDATED REGEX:
     * ^(?=.*[a-z])   - At least one lowercase letter
     * (?=.*[A-Z])    - At least one uppercase letter
     * (?=.*\d)       - At least one number
     * (?=.*[\W_])    - At least one special character (any non-word character)
     * .{8,}          - At least 8 characters total
     */
    const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    useEffect(() => {
        const countries = Country.getAllCountries();
        setAllCountries(countries);
    }, []);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        if (!firstname || !lastname || !email || !password || !country || !phone) {
            return toast.error("Please fill in all fields");
        }

        if (!PWD_REGEX.test(password)) {
            return toast.error(
                "Password too weak."
            );
        }

        const newUser = { firstname, lastname,username, password, email, country, phone };

        try {
            setIsLoading(true);
            const response = await api.post("/account/signup", newUser);
            
            if (response.status === 200 || response.status === 201) {
                toast.success(response.data?.message)
                setIsLoading(false);
                
            } else {
                setIsLoading(false);
                toast.error("Error, your account was not saved");
            }
        } catch (error) {
            setIsLoading(false);
            const message = error.response?.data?.message || "An error occurred during signup";
            toast.error(message);
        }
    };

    return (
        <div className="page">
            <div className='signup userform'>
                <div className="onnize-logo">
                    <img src={logo} alt="onnize" />
                </div>
                
                <form onSubmit={handleSubmit}>
                    <h1 className="form-header">Create your account</h1>
                    
                    <div className="form-input">
                        <label htmlFor="firstname">Firstname</label>
                        <input
                            type="text"
                            id='firstname'
                            placeholder='Firstname'
                            required
                            value={firstname}
                            onChange={(e) => setFirstname(e.target.value)}
                        />
                    </div>

                    <div className="form-input">
                        <label htmlFor="lastname">Lastname</label>
                        <input
                            type="text"
                            id='lastname'
                            required
                            placeholder='Lastname'
                            value={lastname}
                            onChange={(e) => setLastname(e.target.value)}
                        />
                    </div>
                    <div className="username-hp">
                        <label htmlFor="username">username</label>
                        <input
                            type="text"
                            id='username'
                            placeholder='username'
                            value={username}
                            onChange={(e) => setusername(e.target.value)}
                        />
                    </div>

                    <div className="form-input">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id='email'
                            required
                            placeholder='example@email.com'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="form-input">
                        <label htmlFor="password">Set a Password</label>
                        <div className="password-wrapper" style={{ position: 'relative' }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                id='password'
                                required
                                placeholder='8+ chars, 1 Upper, 1 Symbol'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                style={{ width: '100%', paddingRight: '45px' }} 
                            />
                            <button
                                type="button"
                                onClick={togglePasswordVisibility}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontSize: '0.75rem',
                                    color: '#555',
                                    fontWeight: 'bold'
                                }}
                            >
                                {showPassword ? "HIDE" : "SHOW"}
                            </button>
                        </div>
                    </div>

                    <div className="form-input phone-input">
                        <label htmlFor="country">Country & Phone</label>
                        <div className="phone">
                            <select
                                id="country"
                                value={country}
                                required
                                onChange={(e) => setCountry(e.target.value)}
                                style={{ flex: '1' }}
                            >
                                <option value="">Select Country</option>
                                {allCountries.map((c) => (
                                    <option key={c.isoCode} value={c.name}>
                                        {c.name}
                                    </option>
                                ))}
                            </select>
                            
                            <input
                                type="tel"
                                id='phone'
                                required
                                placeholder='703000000'
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                style={{ flex: '2' }}
                            />
                        </div>
                    </div>

                    <div className="form-btn">
                        <button
                            type='submit'
                            className="signup-btn form-btn"
                            disabled={isLoading}
                        >
                            {isLoading ? "Creating..." : "Signup"}
                        </button>
                    </div>
                </form>

                <div className="change-form">
                    <p>Already have an account? <Link to="/login" className='form-link'>Login</Link></p>
                </div>
            </div>
        </div>
    );
};

export default Signup;